import React from 'react';
import RequestCourseForm from '@/components/landing/tutor/request-course-form';
import SEO from '@/components/landing/seo';
import LandingLayout from '@/components/landing/home/LandingLayout';

const RequestCourse = () => {
  return (
    <>
      <SEO
        meta_title={'Course Request | Learnsic'}
        meta_description={'Request course'}
        meta_keywords={'request course, add course, learnsic course'}
        photo={''}
        canonical="request-course"
      />
      <LandingLayout>
        <div className="custom-container">
          <div className="py-5">
            <RequestCourseForm />
          </div>
        </div>
      </LandingLayout>
    </>
  );
};
export default RequestCourse;
